import { render, staticRenderFns } from "./mallGoodsType.vue?vue&type=template&id=bdaf68a8&scoped=true&"
import script from "./mallGoodsType.vue?vue&type=script&lang=js&"
export * from "./mallGoodsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf68a8",
  null
  
)

export default component.exports